module.exports = __webpack_public_path__ + "static/media/glovebox.4c2cb79e.svg";